// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-box[data-v-0221fb96] {\n  width: 100%;\n  margin-top: -2.5rem;\n  z-index: 9999;\n  opacity: 0;\n  cursor: pointer;\n}\n.file-name[data-v-0221fb96] {\n  word-wrap: break-word;\n}", ""]);
// Exports
module.exports = exports;
